import { computed, unref } from 'vue'

export function getModeDetails(mode) {
  return `${mode.defaultName} (${mode.footprint})`
}

function useModeDetails(mode) {
  const itemDetails = computed(() => getModeDetails(unref(mode)))
  return itemDetails
}

export default useModeDetails
